import "./messanger.css"
import {useEffect, useState} from "react";
import {Modal, Button, Form, InputGroup, FormControl} from "react-bootstrap";
import {useSocket, SOCKET_EVENT} from "./SocketProvider";




const CHAT_STATE = {
    NONE:"",
    STARTED:"started",
    FINISHED:"finished"
}

function ReceiveCallModal(props){
    return (
        <>
            <Modal className={"receiveCallModal "}
                {...props}
            >
                <Modal.Header >
                    <Modal.Title>RATUNEK</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Użytkownik aplikacji potrzebuje pomocy.
                    <p>Odbierz rozmowę aby rozpocząć czat z użytkownikiem.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button name={"Odrzuć"} className={"w-50"} variant="danger" onClick={()=>{props.onHide(false)}}>
                        Odrzuć
                    </Button>
                    <Button name={"Odbierz"} className={"w-50"} variant="success" onClick={()=>{props.onHide(true)}} >
                        <b>Odbierz</b>
                    </Button>
                </Modal.Footer>
                <audio id="audio" preload="true" autoPlay={true}  hidden={true} loop={false}>
                    <source src="audio/TF021.WAV" type="audio/wav" />
                </audio>
            </Modal>
        </>
    );
}

function ChatMessage(props){


    const received = props.data.received ? "chat_message received":"chat_message sended";
    const datetime = new Date();
    datetime.setTime(props.data.time_created);
    const timeString = datetime.toLocaleTimeString('pl-PL')

    return (
        <div className={received} >
            <div><span  dangerouslySetInnerHTML={{__html: props.data.message}}></span><span className="text_time_small">{timeString}</span></div>
        </div>
    )
}


function Chat (props){
    const {socket, registerMessageHandler,
        unregisterMessageHandler} = useSocket();
    const ROOM_ID = props['data-roomid']
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState(undefined);
    const [expanded, setExpanded] = useState(true);
    const [state, setState] = useState(props['data-state'])

    if(state !== props['data-state']){
        setState(props['data-state']);
    }

    function onWriteMessage(event){
        setMessage(event.target.value)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if(message.length<=0)
            return;

        const msg = {
            room: ROOM_ID,
            content: message
        }

        socket.emit(SOCKET_EVENT.SEND_MESSAGE, msg, (response)=>{
            const answer = JSON.parse(response)
            answer.received = false;
            setMessages([...messages, answer])
        })
        setMessage("")
    };

    useEffect(()=>{
        if(messages === undefined)
            downloadMessages()

        registerMessageHandler(ROOM_ID, (msg)=>{
            setMessages([...messages, msg])
        });

        return ()=>{
            unregisterMessageHandler(ROOM_ID)
        };
    });

    function downloadMessages(){
        socket.emit(SOCKET_EVENT.GET_MESSAGES, ROOM_ID,(response)=>{
                         setMessages(response)
        })
    }

    const finishChat = ()=>{
        if(state === CHAT_STATE.STARTED && window.confirm("Potwierdź zakończenie czatu z użytkownikiem."))
            socket.emit(SOCKET_EVENT.END_CALL ,ROOM_ID, (response)=>{
                if(response === true){
                    setState(CHAT_STATE.FINISHED)
                    if(props.onClose)
                        props.onClose(ROOM_ID);
                }

            } )
        else {
            if(props.onClose)
                props.onClose(ROOM_ID);
        }
    }

    return (
        <div className={`chat_room ${expanded ? "expanded" : ""} `}>
            <div className={"w-100 chat_cont"}>
                <div className={"chat_bar"}>
                    <span><b>Czat</b></span>
                    <div>
                        <Button name={"Minimalizuj"} size="sm" className={"chat_action_btn"} onClick={()=>{setExpanded(!expanded)}} >_</Button>
                        <Button name={"Zamknij"} size="sm" className={"chat_action_btn"} onClick={finishChat}>X</Button>
                    </div>
                </div>
                <div className={"chat_messages_list"}>

                        {messages && messages.map(msg=><ChatMessage key={ROOM_ID+msg.id} data={msg}/>)}

                </div>

            </div>

            <div className="chat_input">

                { state !== CHAT_STATE.FINISHED &&
                    <Form onSubmit={handleSubmit}>
                        <InputGroup size="sm">
                            <FormControl
                                placeholder="wprowadź wiadomość"
                                aria-label="User message"
                                aria-describedby="basic-addon2"
                                value={message}
                                onChange={onWriteMessage}
                            />
                            <Button name={"Wyślij"} type="submit" variant="warning" >
                                <img src="images/send.svg" alt={"send "} className="sendIcon"/>
                            </Button>
                        </InputGroup>
                    </Form>
                }
                { state === CHAT_STATE.FINISHED &&
                    <div className={"chat_ended"}>Rozmowa została zakończona.</div>
                }
            </div>
        </div>
    )
}


export default function Messanger(){
    const {socket} = useSocket()
    const [receiveCall, setReceiveCall] = useState({
        showModal:false,
        callId:undefined
    })
    const [chats, setChats] = useState([]);


    useEffect(()=>{

        socket.on(SOCKET_EVENT.ON_OFFER, function(callId){
            if(!receiveCall.showModal){
                setReceiveCall({showModal: true, callId: callId})
            }
        })
        socket.on(SOCKET_EVENT.END_CALL, (callId)=>{

            const chat = chats.find((v)=>v.id === callId)

            if(chat === undefined)
                return;

            chat.state = CHAT_STATE.FINISHED;
            setChats([...chats]);
        })

        socket.on(SOCKET_EVENT.DURING_CALL, (calls)=>{

            const activeChats = [];
            for(let x in calls){
                const call = calls[x];
                activeChats.push({id:call.id, state:CHAT_STATE.STARTED});
            }
            if(activeChats.length>0)
            setChats([...activeChats])

        })

        return function cleanup(){
            socket.off(SOCKET_EVENT.ON_OFFER);
            socket.off(SOCKET_EVENT.END_CALL);
            socket.off(SOCKET_EVENT.DURING_CALL);
        }

    })

    function onHideReceiveCallModal(accept){

        if(accept === undefined)
            return;

        if(accept === true) {
            const callID = receiveCall.callId;
            socket.emit(SOCKET_EVENT.ACCEPT_OFFER, callID, (response) => {
                if (response === true) {
                    //add chat
                    setChats([...chats, {id:callID, state: CHAT_STATE.STARTED}])
                }
            });
        }

        setReceiveCall({showModal: false, callId: undefined})
    }

    function onFinishChat(chatId){
        const index = chats.findIndex((v)=>v.id === chatId);

        if(index<0)
            return;

        chats.splice(index,1);

        setChats([...chats]);

    }


    return (
        <>
            <ReceiveCallModal  show={receiveCall.showModal} data-callid={receiveCall.callId} onHide={onHideReceiveCallModal}  />
            <div className={"bottom_chat_bar"}>
                {
                    chats && chats.map((chat) => <Chat key={chat.id} onClose={onFinishChat} data-state={chat.state} data-roomid={chat.id} />)
                }
             </div>
        </>

    )
}